export const CDN_LEVEL_TRAVEL = 'https://jsapi.cdn.level.travel';
export const CDN_LEVEL_TRAVEL_CRM = `${CDN_LEVEL_TRAVEL}/crm`;
export const CDN_LEVEL_TRAVEL_CRM_SOUNDS = `${CDN_LEVEL_TRAVEL_CRM}/sounds`;
